const LAZY_LOAD_CLASSNAME = 'Lazy';
const LAZY_LOADING_CLASSNAME = 'Lazy--loading';
const LAZY_LOADED_CLASSNAME = 'Lazy--loaded';

export { LAZY_LOAD_CLASSNAME, LAZY_LOADING_CLASSNAME, LAZY_LOADED_CLASSNAME };
